import { jsx as _jsx } from "react/jsx-runtime";
import { HowToFindInsiderBrandsQuestion, HowToFindInsiderBrandsAnswer, HowMuchDoesInsiderCostAnswer, CancellationAnswer, FreeShippingAndDutiesAnswer, useInsiderFAQStrings } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/__internal__/content";
import { getSettingInsiderSpecialGrandfatheringEligible } from "@faire/retailer-visitor-shared/settings/getSettingInsiderSpecialGrandfatheringEligible";
import { isNotNull } from "@faire/web--source/common/typescriptUtils";
import { useMemo } from "react";
import React from "react";
export var useInsiderFAQContentsEUR = function() {
    var hasSpecialGrandfathering = getSettingInsiderSpecialGrandfatheringEligible();
    var _useInsiderFAQStrings = useInsiderFAQStrings(), freeShippingAndDutiesQuestion = _useInsiderFAQStrings.freeShippingAndDutiesQuestion, specialGrandfatheringQuestion = _useInsiderFAQStrings.specialGrandfatheringQuestion, specialGrandfatheringAnswer = _useInsiderFAQStrings.specialGrandfatheringAnswer, howMuchDoesInsiderCostQuestion = _useInsiderFAQStrings.howMuchDoesInsiderCostQuestion, cancellationQuestion = _useInsiderFAQStrings.cancellationQuestion, shippingCostsQuestionEUR = _useInsiderFAQStrings.shippingCostsQuestionEUR, shippingCostsAnswerEUR = _useInsiderFAQStrings.shippingCostsAnswerEUR;
    var faq = useMemo(function() {
        return [
            {
                question: freeShippingAndDutiesQuestion,
                answer: /*#__PURE__*/ _jsx(FreeShippingAndDutiesAnswer, {})
            },
            {
                question: /*#__PURE__*/ _jsx(HowToFindInsiderBrandsQuestion, {}),
                answer: /*#__PURE__*/ _jsx(HowToFindInsiderBrandsAnswer, {
                    sectionNumber: "4"
                })
            },
            hasSpecialGrandfathering ? {
                question: specialGrandfatheringQuestion,
                answer: specialGrandfatheringAnswer
            } : null,
            {
                question: shippingCostsQuestionEUR,
                answer: shippingCostsAnswerEUR
            },
            {
                question: howMuchDoesInsiderCostQuestion,
                answer: /*#__PURE__*/ _jsx(HowMuchDoesInsiderCostAnswer, {})
            },
            {
                question: cancellationQuestion,
                answer: /*#__PURE__*/ _jsx(CancellationAnswer, {
                    sectionNumber: "10"
                })
            }
        ].filter(isNotNull);
    }, [
        cancellationQuestion,
        freeShippingAndDutiesQuestion,
        hasSpecialGrandfathering,
        howMuchDoesInsiderCostQuestion,
        shippingCostsAnswerEUR,
        shippingCostsQuestionEUR,
        specialGrandfatheringAnswer,
        specialGrandfatheringQuestion
    ]);
    return faq;
};
